import ReleasedDocumentsTable from '@/components/ReleasedDocumentsTable';
import { useUser } from '@/providers/UserProvider';
import {
  useReleasedDocuments,
  useReleasedDocumentsDownload,
} from '@/hooks/releases/useReleasedDocuments';

interface StudyFinalDocumentsProps {
  studyId: string;
}

/**
 * Study-level Final Documents: a roll-up of everything Univo has released
 * across this study. Ops release at submission level only; this surface is
 * read-only for every customer role.
 */
const StudyFinalDocuments = ({ studyId }: StudyFinalDocumentsProps) => {
  const { userData } = useUser();
  const { documents, isLoading, error } = useReleasedDocuments({
    scope: 'study',
    id: studyId,
  });
  const { download, isDownloading, downloadError, zipExportId } =
    useReleasedDocumentsDownload('study', studyId);

  return (
    <ReleasedDocumentsTable
      documents={documents}
      isLoading={isLoading}
      error={error}
      onDownload={download}
      isDownloading={isDownloading}
      downloadError={downloadError}
      zipExportId={zipExportId}
      userId={userData?.id}
      showSite
    />
  );
};

export default StudyFinalDocuments;
